import {
  Avatar,
  Button,
  Card,
  Col,
  List,
  message,
  Modal,
  Row,
  Typography,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Get from "../services/Get";
import domtoimage from "dom-to-image";

const ViewStudents = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const qrCodeRef = useRef();

  const parent = location.state?.parent;

  const [loading, setLoading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState();
  const [students, setStudents] = useState([]);
  const [qrData, setQrData] = useState();
  const [logo, setLogo] = useState();
  const [profile, setProfile] = useState();

  const showCard = (item) => {
    setLoading(true);
    Get.getSingleStudent(item.id)
      .then((res) => {
        setProfile(res.profile);
        setQrData(res.qr_code);
        setLogo(res.logo);
        setSelectedStudent(res.data);
        setIsModalOpen(true);
      })
      .catch((error) => {
        console.error(error);

        message.error(error);
      })
      .finally(() => setLoading(false));
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleDownload = () => {
    if (qrCodeRef.current) {
      domtoimage
        .toBlob(qrCodeRef.current, {
          cacheBust: true,
          bgcolor: "white",
          useCORS: true, // Ensures images from other origins are included
        })
        .then((blob) => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${qrData.qr_code || "unknown"}.png`;
          link.click();
        })
        .catch((error) => {
          console.error("Error generating image:", error);
        });
    }
  };

  const handlePrint = () => {
    if (qrCodeRef.current) {
      domtoimage
        .toPng(qrCodeRef.current)
        .then((dataUrl) => {
          const newWindow = window.open("", "_blank");
          newWindow.document.write(`
                          <html>
                              <head><title>Print Gate Pass</title></head>
                              <body style="text-align: center;">
                                  <img src="${dataUrl}" style="width: 300px;" />
                                  <script>window.onload = function() { window.print(); window.onafterprint = function() { window.close(); }; }</script>
                              </body>
                          </html>
                      `);
          newWindow.document.close();
        })
        .catch((error) =>
          console.error("Error generating print image:", error)
        );
    }
  };

  const getStudents = () => {
    setLoading(true);
    Get.getStudents(parent.id)
      .then((res) => {
        setStudents(res.data);
      })
      .catch((error) => {
        message.error(error);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getStudents();
  }, []);

  return (
    <Row justify={"center"}>
      <Col span={14}>
        <List
          header={<Typography.Title level={4}>Students</Typography.Title>}
          bordered
          loading={loading}
          dataSource={students}
          renderItem={(item) => (
            <List.Item
              actions={[
                <Button
                  type="primary"
                  className="form-btn"
                  onClick={() => showCard(item)}
                >
                  View ID Card
                </Button>,
              ]}
            >
              <List.Item.Meta
                title={item.name}
                avatar={
                  <Avatar
                    size={64}
                    src={
                      <img
                        src={`https://manage.rebatedekho.com/uploads/student/${item.profile}`}
                      />
                    }
                  />
                }
                description={`Class: ${item.class} - ${item.section} | Admission No. ${item.admission_no}`}
              />
            </List.Item>
          )}
        />

        <Modal
          open={isModalOpen}
          title="Student ID Card"
          onCancel={handleCancel}
          centered
          footer={[
            <Button key="back" onClick={handleCancel}>
              Cancel
            </Button>,
            <Button
              key="print"
              type="primary"
              loading={processing}
              onClick={handlePrint}
              className="form-btn"
            >
              Print
            </Button>,
            <Button
              key="download"
              type="primary"
              loading={processing}
              onClick={handleDownload}
              className="form-btn"
            >
              Download
            </Button>,
          ]}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              padding: 20,
              backgroundColor: "#f9f9f9",
              borderRadius: 10,
            }}
          >
            <Card
              style={{
                width: 300,
                textAlign: "center",
                borderRadius: 12,
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                padding: 20,
                backgroundColor: "#ffffff",
                border: "1px solid #ddd",
              }}
              ref={qrCodeRef}
            >
              {/* Profile Image */}
              <div style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src={profile}
                  alt="Profile"
                  style={{
                    width: 120,
                    height: 120,
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "4px solid #a6cc43",
                  }}
                />
              </div>

              {/* Student Info */}
              <Typography.Title
                level={4}
                style={{ marginTop: 15, color: "#333" }}
              >
                {selectedStudent?.name}
              </Typography.Title>

              <Typography.Text strong style={{ fontSize: 16, color: "#666" }}>
                Class: {selectedStudent?.class} | Section:{" "}
                {selectedStudent?.section}
              </Typography.Text>

              {/* Admission Number Badge */}
              <div
                style={{
                  background: "#a6cc43",
                  color: "white",
                  padding: "8px 15px",
                  borderRadius: 8,
                  marginTop: 15,
                  fontWeight: "bold",
                  fontSize: 16,
                }}
              >
                {selectedStudent?.admission_no}
              </div>

              {/* QR Code & Logo Section */}
              <Row
                style={{ marginTop: 20 }}
                justify="space-between"
                align="middle"
              >
                <Col span={12} style={{ textAlign: "center" }}>
                  <img src={qrData} width={90} alt="QR Code" />
                </Col>
                <Col span={12} style={{ textAlign: "center" }}>
                  <img src={logo} width={120} alt="Logo" />
                </Col>
              </Row>
            </Card>
          </div>
        </Modal>
      </Col>
    </Row>
  );
};

export default ViewStudents;
